import {
    Box 
} from '@mui/material';
import {
    makeStyles 
} from '@mui/styles';

type Props = {
    children: JSX.Element | JSX.Element[],
    overflowVisible?: boolean,
    shiftUp?: boolean,
    ignoreTranslate?: boolean,
    backgroundColor?: string
};

export const Card = ({
    children,
    overflowVisible = false,
    shiftUp = false,
    ignoreTranslate = false,
    backgroundColor 
}: Props): JSX.Element => {
    const useStyles = makeStyles((theme) => ({
        cardContainer: {
            width: '100%',
            height: 'inherit',
            backgroundColor: backgroundColor ?? theme.palette.white,
            borderRadius: shiftUp ? 0 : '24px 24px 0 0',
            margin: '0 auto',
            maxWidth: '692px',
            transform: shiftUp ? ignoreTranslate ? 'translate(0)' : 'translate(0, -40px)' : 'translate(0)'
        },
        card: {
            backgroundColor: backgroundColor ?? theme.palette.white,
            borderRadius: shiftUp ? 0 : '24px 24px 0 0',
            padding: shiftUp ? '0 24px' : '24px',
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100px',
            height: shiftUp ? '100vh' : 'calc(100vh - 40px)',
            overflow: 'hidden',
            lineHeight: 1,
        },
        overflowVisible: {
            overflow: 'visible'
        }
    }));
    const classes = useStyles();

    return (
        <Box className={classes.cardContainer}>
            <Box className={`${classes.card} ${overflowVisible ? classes.overflowVisible : null}`}>
                {children}
            </Box>
        </Box>
    );
};

export default Card;
